import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  linkToHome?: boolean;
}
export function Logo({
  size = 'md',
  className = '',
  linkToHome = true
}: LogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl'
  };
  const logoContent = <div className={`flex items-center ${linkToHome ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''} ${className}`} data-id="element-378">
      <span className={`font-light text-slate-900 ${sizeClasses[size]} tracking-tight`} data-id="element-379">
        Jua
      </span>
    </div>;
  if (linkToHome) {
    return <Link to="/" className="no-underline" data-id="element-380">
        {logoContent}
      </Link>;
  }
  return logoContent;
}